import React from 'react';
import { SquareBadge, StepItem } from '../../../../../../components/Step';
import { Container, Ul, P, StepCopy, StepContentWrapper, Subtitle, Title, Left, LeftContent, Right } from './styles';

const BatteryUses = ({ terms }) => (
    <Container>
        <Left>
            <LeftContent>
                <Title>Buy 1, Get Many</Title>
                <Subtitle>
                    Solvana batteries give you flexibility.
                </Subtitle>
            </LeftContent>
        </Left>

        <Right>
            <Ul>
                <StepItem
                    title="Safety & Peace of Mind"
                    icon={<SquareBadge size="15px">1</SquareBadge>}
                >
                    <StepContentWrapper>
                        <StepCopy>
                            <P>
                                An ESS adds a crucial layer of safety and security to your PV solar-generating system. Typically, when the grid fails, your PV solar-generating system powers down for safety reasons. With PV solar-generating system + ESS, now when the electrical utility grid fails, your PV solar-generating system will still be operational. The ESS can seamlessly manage power and energy from the PV solar-generating system, the utility grid, and an optional fossil fuel generator. Adding the right ESS gives you backup power and energy when you need it most, keeping your PV solar-generating system functional and operational even when the grid goes down!
                            </P>
                        </StepCopy>
                    </StepContentWrapper>
                </StepItem>

                <StepItem
                    title="Performance"
                    icon={<SquareBadge size="15px">2</SquareBadge>}
                >
                    <StepContentWrapper>
                        <StepCopy>
                            <P>
                                Use your ESS power when it saves you the most money. In addition to supplying electricity during brownouts and blackouts, you can maximize your avoided electrical costs (Value of Solar) by timing when your ESS is charging and discharging. And by finding the sweet spot between any varying rate schedules and time of use charges, you can save a significant amount of money on your electricity bills by discharging power from the ESS during the times when electrical utility grid rates are highest. Solvana can even add equipment and components to your new ESS that allow you to program what time electrical load circuits are available and unavailable, all of which you can do on your smartphone!
                            </P>
                        </StepCopy>
                    </StepContentWrapper>
                </StepItem>

                <StepItem
                    title="Independence"
                    icon={<SquareBadge size="15px">3</SquareBadge>}
                >
                    <StepContentWrapper>
                        <StepCopy>
                            <P>
                                You must be connected to your electrical utility grid by law. However, with PV Solar + ESS designed by Solvana, you will be able to run your PV solar-generating system whether the electrical utility grid is up and running or not. Meaning you will not have to rely on anyone else to keep the lights on. It will be like being on your very own energy island. And it is all done automatically!
                            </P>
                        </StepCopy>
                    </StepContentWrapper>
                </StepItem>
                <StepItem
                    title="Generator Compatibility"
                    icon={<SquareBadge size="15px">4</SquareBadge>}
                >
                    <StepContentWrapper>
                        <StepCopy>
                            <P>
                                For even more safety, our backup systems are compatible with generators. Our Hybrid inverters manage all of your energy sources to optimize value. So no mater the circumstances, you can power your home from solar PV, batteries, the grid, or a generator.
                            </P>
                        </StepCopy>
                    </StepContentWrapper>
                </StepItem>
                {!terms.resiToggle ?
                    <StepItem
                        title="Demand Response"
                        icon={<SquareBadge size="15px">5</SquareBadge>}
                    >
                        <StepContentWrapper>
                            <StepCopy>
                                <P>
                                    ESS Demand Response can also significantly reduce electricity costs. An ESS can be programmed to discharge power during the times when your historical Demand Charges are at their peak, and by doing so, Solvana can lower your Demand Charges and even drop your electricity tariff rates. Customers who choose ESS to reduce their Demand (kW) Charges can see huge savings!
                                </P>
                            </StepCopy>
                        </StepContentWrapper>
                    </StepItem>
                    : null }
            </Ul>
        </Right>
    </Container>
);

export default BatteryUses;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/ESSPoints/BatteryUses/BatteryUses.js